import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-close-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`
})
export class CloseIconComponent {

}
